// extracted by mini-css-extract-plugin
export default {"introContainer":"about_introContainer__FgbYt","aboutContainer":"about_aboutContainer__Bt3Zr","imageContainer":"about_imageContainer__Z81fa"};